export const VALIDATION_MESSAGE = {
  EMAIL: 'Invalid email address.',
  PHONE: 'Invalid phone number.',
};
